import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';

@Component({
  selector: 'lib-document-button-renderer',
  templateUrl: './document-button-renderer.component.html',
  styleUrls: ['./document-button-renderer.component.scss']
})
export class DocumentButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  icon_visibility!:string;
  routerLinkValue!:string;
  text!:string;

  constructor(){}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.icon_visibility = this.params.icon_visibility || null;
    this.routerLinkValue = this.params.routerLinkValue || null;
    this.text = this.params.text || null;
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkValue = _.isFunction(dataParams.routerLinkValue) ? dataParams.routerLinkValue(params) : _.get(params.data, dataParams.routerLinkValue);
    this.text = _.isFunction(dataParams.text) ? dataParams.routerLinkValue(params) : _.get(params.data, dataParams.text);
    
    return false;
  }

  onClick($event: any) {
    if(this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component

      const params = {
        event: $event,
        rowData: this.params.node.data
      }

      this.params.onClick(this.params);
    }  
  }

 
}
